import { createRemoteSlice, createRemoteSliceConfig } from 'src/store/lib/createRemoteSlice';
import z from 'zod';

export const confirmLeavingWorkspaceCloseResults = ['cancel', 'dont-save', 'save', 'saved'] as const;
export type ConfirmLeavingWorkspaceCloseResult = (typeof confirmLeavingWorkspaceCloseResults)[number];

export const confirmLeavingWorkspace = createRemoteSliceConfig({
    name: 'confirmLeavingWorkspace',
    state: z.object({
        isOpen: z.boolean(),
        workspacePrimary: z.boolean(),
        lastCloseResult: z.enum(confirmLeavingWorkspaceCloseResults).nullable(),
    }),
    actions: {
        openModal: z.void(),
        closeModal: z.enum(confirmLeavingWorkspaceCloseResults),
        saveThenCloseModal: z.void(),
        setWorkspacePrimary: z.boolean(),
    },
});

// Needs to be annotated with PURE to ensure it is not bundled when not used
export const confirmLeavingWorkspaceSlice = /*#__PURE__*/ createRemoteSlice({
    config: confirmLeavingWorkspace,
    initialState: {
        isOpen: false,
        workspacePrimary: false,
        lastCloseResult: null,
    },
    reducers: {
        openModal(state) {
            return {
                ...state,
                isOpen: true,
                workspacePrimary: false,
                lastCloseResult: null,
            };
        },
        closeModal(state, action) {
            return {
                ...state,
                isOpen: false,
                workspacePrimary: false,
                lastCloseResult: action.payload,
            };
        },
        setWorkspacePrimary(state, action) {
            return {
                ...state,
                workspacePrimary: action.payload,
            };
        },
        saveThenCloseModal(state) {
            return state;
        },
    },
});
